// src/i18n/config.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getCookie } from "@/utils/cookies";

import deTranslations from "./locales/de.json";
import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";
import nlTranslations from "./locales/nl.json";
import svTranslations from "./locales/sv.json";

// Get saved language from cookie or use default
const savedLanguage = getCookie("language") || "nl";

// Import language files
i18n.use(initReactI18next).init({
    resources: {
        nl: { translation: nlTranslations },
        en: { translation: enTranslations },
        de: { translation: deTranslations },
        fr: { translation: frTranslations },
        sv: { translation: svTranslations },
    },
    lng: savedLanguage, // Use saved language
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false, // Prevent SSR issues
    },
});

export default i18n;
